/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MedicalExaminationApiModel { 
    id: number;
    code: string;
    name: string;
    capabilityDefinitionsId: number;
    examinationTypeId: number;
}

